<div fxLayout="column" fxFlexFill *ngIf="!loaders.page">

  <div fxLayout="column" fxFlex class="scrolled layout-padd">


    <!-- Client desabonnement -->
    <div fxLayoutAlign="end center" class="layout-padd">
      <button (click)="delete_account()" mat-raised-button class="warn" angulartics2On="click"
              angularticsAction="delete_account"
              angularticsCategory="delete_account">{{"client.menu.delete_account" | translate}}
      </button>
    </div>


    <!-- Client pic -->
    <div fxLayoutAlign="center center" class="layout-padd" fxHide.xs *ngIf="user$">
      <img src="{{user$.photoURL}}" class="profil-pic clicked rad-bord" ngClass.xs="pic-xs" *ngIf="user$.photoURL">
      <img src="assets/img/user/emptyuser.png" class="profil-pic clicked rad-bord" ngClass.xs="pic-xs"
           *ngIf="!user$.photoURL">
    </div>


    <!-- Barcode ref client -->
    <div class="layout-padd">

      <div fxLayout="column" fxLayoutAlign="center center" class="text-center">
        <span class="mat-subheading-1">{{"accountComp.refCustomer" | translate}}</span>
        <span class="mat-subheading-1">{{"accountComp.barCode" | translate}}</span>
      </div>

      <app-barcode-client fxLayoutAlign="center center" [clientAccount]="clientAccount$"
                          *ngIf="clientAccount$"></app-barcode-client>

    </div>

    <!-- Displayed messages -->

    <mat-card fxLayout="row" fxLayoutAlign="center center" class="warn" *ngIf="error$ === 'errHappen'">
      <div fxFlex="10%" fxLayoutAlign="start center">
        <mat-icon>warning</mat-icon>
      </div>
      <div fxFlex fxLayoutAlign="center center" class="text-center">
        <span class="mat-subheading-2">{{"loginComp.error" | translate}}</span>
      </div>
    </mat-card>


    <mat-card fxLayout="row" fxLayoutAlign="center center" class="great" *ngIf="error$ === 'successmail'">
      <div fxFlex="10%" fxLayoutAlign="start center">
        <mat-icon>email</mat-icon>
      </div>
      <div fxFlex fxLayoutAlign="center center" class="text-center">
        <span class="mat-subheading-2"
              [innerHTML]="'register.message.confemail' | translate:{'email': currEmail}"></span>
      </div>
    </mat-card>


    <!-- success -->
    <mat-card fxLayout="row" fxLayoutAlign="center center" class="great" *ngIf="error$ === 'successpassword'">
      <div fxFlex="10%" fxLayoutAlign="start center">
        <mat-icon>https</mat-icon>
      </div>
      <div fxFlex fxLayoutAlign="center center" class="text-center">
        <span class="mat-subheading-2">{{"myaccount.success.password" | translate}}</span>
      </div>
    </mat-card>
    <!-- successfirstname successlastname successphone successbirth -->

    <mat-card fxLayout="row" fxLayoutAlign="center center" class="great" *ngIf="error$ === 'successfirstname'
          || error$ === 'successlastname'
          || error$ === 'successphone'
          || error$ === 'successbirth'
          || error$ === 'successAll'">

      <div fxFlex="10%" fxLayoutAlign="start center">
        <mat-icon>person</mat-icon>
      </div>

      <div fxFlex fxLayoutAlign="center center" class="text-center">
        <span class="mat-subheading-2"
              *ngIf="error$ === 'successfirstname'">{{"accountComp.successfirstname" | translate}}</span>
        <span class="mat-subheading-2"
              *ngIf="error$ === 'successlastname'">{{"accountComp.successlastname" | translate}}</span>
        <span class="mat-subheading-2"
              *ngIf="error$ === 'successphone'">{{"accountComp.successphone" | translate}}</span>
        <span class="mat-subheading-2"
              *ngIf="error$ === 'successbirth'">{{"accountComp.successbirth" | translate}}</span>
        <span class="mat-subheading-2" *ngIf="error$ === 'successAll'">{{"accountComp.successAll" | translate}}</span>
      </div>

    </mat-card>


    <!-- error  log  -->
    <mat-card fxLayout="row" fxLayoutAlign="center center" class="warn" *ngIf="error$ === 'errneedlog'">
      <div fxFlex="10%" fxLayoutAlign="start center">
        <mat-icon>pan_tool</mat-icon>
      </div>
      <div fxLayout="row" fxLayout.lt-md="column" fxFlex fxLayoutAlign="center center" fxLayoutGap="20px"
           class="text-center">
        <div>
          <span class="mat-subheading-2">{{"myaccount.err.needlog" | translate}}</span>
        </div>
        <div>
          <button mat-raised-button (click)="reLog()" angulartics2On="click" angularticsAction="reLoginRedirect"
                  angularticsCategory="clientAccount">{{"main.word.login" | translate}}</button>
        </div>
      </div>
    </mat-card>

    <!-- error mail -->
    <mat-card fxLayout="row" fxLayoutAlign="center center" class="warn" *ngIf="error$ === 'erremailalreadyuse'">
      <div fxFlex="10%" fxLayoutAlign="start center">
        <mat-icon>email</mat-icon>
      </div>
      <div fxLayout="column" fxFlex fxLayoutAlign="center center" fxLayoutGap="10px" class="text-center">
        <span class="mat-subheading-2"
              [innerHTML]="'register.message.takenemail' | translate:{'email': currEmail}"></span>
      </div>
    </mat-card>


    <mat-card id="accountMatCard">

      <form [formGroup]="accountForm" (ngSubmit)="onSubmit()">

        <!-- firstname -->
        <section id="firstname" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">

          <mat-icon class="primary-ico">person</mat-icon>


          <mat-form-field class="full-w">
            <mat-label>{{"registerComp.firstname" | translate}}</mat-label>
            <input matInput type="text" (keydown.space)="$event.preventDefault()" formControlName="firstName">

            <mat-error fxLayout fxLayoutAlign="start center" *ngIf="accountForm.controls['firstName'].errors?.required">
              <span class="mat-caption">{{"main.err.reqpass" | translate}}</span>
            </mat-error>
            <mat-error fxLayout fxLayoutAlign="start center" *ngIf="accountForm.controls['firstName'].errors?.pattern">
              <span class="mat-caption">{{"registerComp.invalidFormat" | translate}}</span>
            </mat-error>
          </mat-form-field>

        </section>

        <!-- lastname -->
        <section id="lastname" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">


          <mat-icon class="primary-ico">person</mat-icon>


          <mat-form-field class="full-w">
            <mat-label>{{"registerComp.name" | translate}}</mat-label>
            <input matInput type="text" (keydown.space)="$event.preventDefault()" formControlName="lastName">

            <mat-error fxLayout fxLayoutAlign="start center" *ngIf="accountForm.controls['lastName'].errors?.required">
              <span class="mat-caption">{{"main.err.reqpass" | translate}}</span>
            </mat-error>
            <mat-error fxLayout fxLayoutAlign="start center" *ngIf="accountForm.controls['lastName'].errors?.pattern">
              <span class="mat-caption">{{"registerComp.invalidFormat" | translate}}</span>
            </mat-error>
          </mat-form-field>

        </section>


        <!-- society -->
        <section id="society" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">

          <mat-icon class="primary-ico">business</mat-icon>

          <mat-form-field class="full-w">
            <mat-label>{{"adressComponent.soc" | translate}} <span style="font-size: 12px;">({{"optional" | translate}}
              )</span></mat-label>
            <input matInput type="text" (keydown.space)="$event.preventDefault()" formControlName="society">

          </mat-form-field>

        </section>

        <!-- email -->
        <section id="email" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">


          <mat-icon class="primary-ico">email</mat-icon>


          <mat-form-field class="full-w">

            <mat-label>{{"main.word.email" | translate}}</mat-label>
            <input type="email" matInput (keydown.space)="$event.preventDefault()" formControlName="email"
                   autocomplete="username">

            <mat-error fxLayout fxLayoutAlign="start center" *ngIf="accountForm.controls['email'].errors?.required">
              <span class="mat-caption">{{"main.err.reqemail" | translate}}</span>
            </mat-error>
            <mat-error fxLayout fxLayoutAlign="start center" *ngIf="accountForm.controls['email'].errors?.email">
              <span class="mat-caption">{{"main.err.emailformat" | translate}}</span>
            </mat-error>
          </mat-form-field>
        </section>

        <!-- birth -->
        <section id="birth" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">

          <mat-icon class="primary-ico">cake</mat-icon>

          <mat-form-field class="full-w">
            <mat-label>{{"accountComp.Birthday" | translate}}</mat-label>
            <input matInput [matDatepicker]="picker" [min]="minDate" [max]="maxDate"
                   (keydown.space)="$event.preventDefault()" formControlName="birth">
            <mat-hint>JJ/MM/AAAA</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>

          </mat-form-field>


        </section>

        <!-- addresses -->
        <section id="addresses" fxLayout="row" fxLayoutAlign="space-around center">

          <div fxLayoutAlign="start center" fxLayoutGap="20px">
            <mat-icon class="primary-ico">contact_mail</mat-icon>
            <span class="mat-subheading-2"> {{"client.menu.addresses" | translate | capitalize}}</span>
          </div>

          <div fxFlex class="dot"></div>

          <div fxLayoutAlign="center" (click)="openDialAddress()">
            <button mat-icon-button type="button" onclick="this.blur();"
                    matTooltip="{{'accountComp.changeAdress' | translate}}">
              <mat-icon class="dark-ico">edit</mat-icon>
            </button>
          </div>

        </section>

        <!-- phone -->
        <section id="phone" fxLayout="row" fxLayoutAlign="space-around center">

          <div fxLayoutAlign="start center" fxLayoutGap="20px">
            <mat-icon class="primary-ico">phone</mat-icon>
            <span class="mat-subheading-2"> {{"Téléphone" | translate | capitalize}}</span>
          </div>

          <div fxFlex class="dot"></div>

          <div fxLayoutAlign="center" (click)="openDialPhone()">
            <button mat-icon-button type="button" onclick="this.blur();"
                    matTooltip="{{'accountComp.changePhone' | translate}}">
              <mat-icon class="dark-ico">edit</mat-icon>
            </button>
          </div>

        </section>

        <!-- password -->
        <section id="password" fxLayout="row" fxLayoutAlign="space-around center">

          <div fxLayoutAlign="start center" fxLayoutGap="20px">
            <mat-icon class="primary-ico">https</mat-icon>
            <span class="mat-subheading-2">{{"main.word.password" | translate}}</span>
          </div>

          <div fxFlex class="dot"></div>

          <div fxLayoutAlign="center" (click)="openDialPassword()">
            <button mat-icon-button type="button" onclick="this.blur();"
                    matTooltip="{{'accountComp.changePass' | translate}}">
              <mat-icon class="dark-ico">edit</mat-icon>
            </button>
          </div>

        </section>

        <!-- enable_marketing -->
        <section id="enable_marketing" fxLayout="row" fxLayoutAlign="start center" style="padding:20px 4px ;">

          <mat-checkbox formControlName="enable_marketing" color="primary">
            <span class="mat-subheading-1" ngClass.xs="mat-caption"
                  style="width: 15px">{{"enable_marketing.acceptTerms"|translate}}</span>
          </mat-checkbox>


        </section>

        <section id="submit">
          <div fxLayout="row" class="full-w" fxLayoutAlign="end">
            <button mat-raised-button type="submit" class="primary" angulartics2On="click"
                    angularticsAction="submitForm" angularticsCategory="clientAccount">{{"main.word.update" |
              translate}}</button>

          </div>
        </section>

      </form>

    </mat-card>

  </div>

</div>
